module.exports = __webpack_public_path__ + "static/media/uy.ac52c1b3.svg";